<template >
    <v-app>
        <!-- //////////////////////////////////////////////////////////////suggested bad ddresses dialog/////////////////////////////////////////// -->
       <v-dialog v-model="dialogbadaddress">
           <v-sheet class="pa-6">
               <v-row justify="center">
                   <h2>This address is not under the City of Bremerton's Jurisdiction</h2>
               </v-row>
               <v-row justify="center">
                   You do not need to register this address with the City of Bremerton as a rental
               </v-row>
               <v-divider class="my-6"></v-divider>
               <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="dialogbadaddress=false">close</v-btn>
               </v-row>
           </v-sheet>
       </v-dialog>
        <!-- ///////////////////////////////////////////////////////////////notification dialog///////////////////////////////////////////////// -->
        <v-dialog v-model="dialogdone" width="400" persistent>
            <v-card width="400">
                <v-card-title>
                    Thank You!
                </v-card-title>
                <v-card-text>
                    The city has been notified of your application and will email you your account number and information upon approval of the account.
                    <br/><br/>
                    <v-row justify="center">
                        <h4>The email will be sent to</h4>
                    </v-row>
                    <v-row justify="center">
                        <h4>{{applemail}}</h4>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    Thank you again for working with the City of Bremerton!
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="home">Home</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- /////////////////////////////////////////////////////// email account dialog  ///////////////////////////////////// -->
        <v-dialog 
            v-model="dialogemaillist" 
            overlay-opacity=".9"
            width="700"
            >
            <v-row class="ma-0 pa-0" justify="center">
                <v-sheet 
                    rounded 
                    :color="dialogcolor" 
                    class="px-4 py-4" 
                    width="700">
                    <v-row class="ma-0 pa-0"  justify="center">
                        <h2>Accounts with {{poemail}}</h2>
                    </v-row>
                    <v-row class="ma-0 pa-0"  justify="center">
                        If your account is in the list, please choose that account to renew.
                    </v-row>
                    <v-row class="ma-0 pa-0"  justify="center">
                        If your account is not in the list, please click the 'ADD NEW ACCOUNT' button below.    
                    </v-row>
                    <v-row class="mx-3 mb-8 mt-6">
                        <table>
                            <thead>
                            <tr><th><b></b></th><th><b>Account</b></th><th><b>Status</b></th><th><b>Business Name</b></th></tr>
                            </thead>
                            <tr v-for="x in emaillist" :key="x.prikey">
                                <td >
                                    <center>
                                        <v-hover v-slot="{ hover }">
                                            <v-btn  
                                                height="20" 
                                                dense
                                                @click="renew(x)" 
                                                small 
                                                color="primary" 
                                                rounded 
                                                :elevation="hover ? 12 : 2" 
                                                class="ma-2 pa-0">renew</v-btn>
                                        </v-hover>
                                    </center>
                                </td><td>{{x.AcctNo}}</td><td>{{x.Status}}</td><td>{{x.BusName}}</td>
                            </tr>
                        </table>
                    </v-row>
                    <v-divider class="mb-8"></v-divider>
                    <v-row class="mx-3 mb-4">
                        <v-btn width="200" height="50" color="teal darken-4" rounded dark elevation="12" @click="poemailtested=true, dialogemaillist=false">Add New Account</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn width="200" height="50" color="teal darken-4" rounded dark elevation="12" @click="dialogemaillist=false">close</v-btn>
                    </v-row>
                </v-sheet>
            </v-row>
        </v-dialog>
        <!-- /////////////////////////////////////////////////////// generic dialog  ///////////////////////////////////// -->
        <v-dialog v-model="dialog" overlay-opacity=".9">
            <v-row class="ma-0 pa-0" justify="center">
                <v-sheet rounded :color="dialogcolor" class="ma-12 pa-12" width="500">
                    <v-row justify="center">
                        <h2>{{dialogtitle}}</h2>
                    </v-row>
                    <v-row class="ma-8" justify="center">
                        {{dialogtext}}
                    </v-row>
                    <v-divider class="mb-8"></v-divider>
                    <v-row justify="end">
                        <v-btn width="100" color="green darken-4" dark elevation="12" @click="home" v-if="gohome">Main Page</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn width="100" color="green darken-4" dark elevation="12" @click="dialog=false">Close</v-btn>
                    </v-row>
                </v-sheet>
            </v-row>
        </v-dialog>
        <!-- /////////////////////////////////////////////////dialog for sign //////////////////////////////////////////// -->
        <v-dialog width="500" persistent v-model="step4">
            <v-card
            class="py-8"
            >
                <v-card-title>
                    <v-row justify="center">
                    
                    </v-row>
                    </v-card-title>
                <v-divider class="mt-1 mb-8"></v-divider>
                <v-card-text>
                    <!--                       //////////////////////////////////////property is residential so have them sign the landlord tenant act    -->
                    <div v-if="llta">
                        The following certification applies only to landlords with Residential Property:<br/><br/>
                        <b>DECLARATION OF COMPLIANCE</b><br/>By checking the box below, I certify, to the best of my knowledge, that: 
                        <br/><br/><b>1)</b> The information provided on this form is true and correct; 
                        <br/><br/><b>2)</b> I have listed above all my residential rental properties located in the City of Bremerton; and 
                        <br/><br/><b>3)</b> Each dwelling unit on such property complies with the standards set forth in the State Landlord Tenant Act, 
                        <a target="_blank" href="https://apps.leg.wa.gov/rcw/default.aspx?cite=59.18.060">Title 59, Section 59.18.060</a> and do not present conditions that endanger or impair the health or safety of the tenants. 
                        <br/><br/>
                        The <a target="_blank" href="https://landlords.bremertonwa.gov/checklist.pdf">Residential Rental Inspection Checklist</a> provides a list of the areas that should be inspected to comply with the standards set forth in RCW <a target="_blank" href="https://apps.leg.wa.gov/rcw/default.aspx?cite=59.18.060">59.18.060</a>. 
                        The checklist does not need to be returned with this application. I understand that if my residential rental properties are found to be in non-compliance 
                        with the health and safety requirements outlined in <a target="_blank" href="https://apps.leg.wa.gov/rcw/default.aspx?cite=59.18.060">RCW 59.18.060</a>,
                            that per Bremerton Municipal <a target="_blank" href="https://www.codepublishing.com/WA/Bremerton/html/Bremerton05/Bremerton0506.html">Code 5.06</a>, code enforcement action may be taken.

                            <v-divider class="my-4"></v-divider>
                            <v-row>
                                <v-sheet v-if="!signature" rounded elevation="6" class="pa-2 ma-2" color="red lighten-4">
                                    <v-row>
                                    <v-col cols="2">
                                        <v-row justify="end">
                                            <v-checkbox v-model="signature"></v-checkbox>
                                            <v-divider vertical class="mx-4 mt-4"></v-divider>
                                        </v-row>
                                    </v-col>
                                    <v-col >
                                        <v-row justify="start" class="pa-2">
                                            
                                                By checking the box to the left, I certifiy that the properties being rented out are in compliance with standards set forth in the State Landlord Tenant Act, Title 59, Section 59.18.060 
                                            
                                        </v-row>
                                    </v-col>
                                    </v-row>
                                </v-sheet>

                                <v-sheet class="ma-2 pa-2" v-else>
                                    <v-row>
                                        <v-col cols="2">
                                            <v-row justify="end">
                                                <v-checkbox v-model="signature"></v-checkbox>
                                                <v-divider vertical class="mx-4"></v-divider>
                                            </v-row>
                                        </v-col>
                                        <v-col >
                                            <v-row justify="start">
                                                By checking the box to the left, I certifiy that the properties being rented out are in compliance with standards set forth in the State Landlord Tenant Act, Title 59, Section 59.18.060 
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-row>
                    </div>  
                    <div v-else>
                        <v-row class="mt-4  pt-4" justify="center">
                            <h2>Thank you for doing business</h2> 
                        </v-row>
                        <v-row class="mb-4 mt-6 pb-4" justify="center">
                            <h2>with the City of Bremerton!</h2>
                        </v-row>
                    </div>
                    <v-divider class="my-4"></v-divider>
                    <div>
                        <v-row justify="center">
                            Clicking the 'SUBMIT' button below will take you to a 
                        </v-row>
                        <v-row justify="center">
                            secure third party payment site to process the cost of the license.
                        </v-row>
                     
                        <v-row class="mt-6" justify="center">
                         <h3>You will recieve an email from the City of Bremerton</h3>
                        </v-row>
                        <v-row justify="center">
                         <h3>with your license number and logon instructions</h3>
                        </v-row>
                        <v-row justify="center">
                            <h3>when the license is approved.</h3>
                        </v-row>
                        
                        <v-row class="mt-6" justify="center">
                        The cost of the license is &nbsp;<b>${{bill}}</b>
                        </v-row>
                        <v-row class="mt-6" justify="center">
                        <h4>(If a new tab doesn't open in your browser then please</h4>
                    </v-row>
                        <v-row  justify="center">
                        <h4>check your browser settings and popup blockers)</h4>
                        </v-row>
                   </div>
                </v-card-text>
                <v-divider class="my-4"></v-divider>
                 <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!signature && llta == true" text disabled>(please click the checkbox above)</v-btn>
          <v-btn
            v-if="signature == true || llta == false"
            color="blue darken-1"
            text
            @click="sendemail"
          >
            Submit
          </v-btn>
          <v-btn
            v-if="signature == false && llta == true"
            color="blue darken-1"
            text
            disabled
          >
            Submit
          </v-btn>
        </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- /////////////////////////////////////////////////dialog for error //////////////////////////////////////////// -->
        <v-dialog   
            
            v-model="error"
            width="450"
            >
            <v-row justify="center">
                <v-col class="ma-8">
                <v-card
                width="400"
                rounded
                class="py-8"
                >
                    <v-card-text>
                        <v-row justify="center">
                            <h1 class="ma-2">Our Appologies</h1>
                        </v-row>
                        <v-row class="ma-3" justify="center"> 
                            <h1>There was an ERROR!</h1>
                        </v-row>
                    
                    <v-divider class="ma-8"></v-divider>

                    
                        <b class="ml-2 mt-8">Please try again later or contact us at:</b><br/><br/>

                        <b class="ml-2 mt-8">Email:</b> <a href="taxinfo@ci.bremerton.wa.us">taxinfo@ci.bremerton.wa.us</a>
                        <br/><br/>
                        <b class="ml-2 mt-8">Office:</b> 345 6th St., Suite 600
                        <br/><br/>
                        <b class="ml-2 mt-8">Mailing:</b> 345 6th St., Suite 100 Bremerton, WA 98337
                        <br/>
                        
                        <br/>
                        <b class="ml-2 mt-8">Ph:</b> 360-473-5311
                    </v-card-text>
               
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            color="blue darken-1"
                            elevation="12"
                            @click="home"
                        >
                            Home
                        </v-btn>
                    </v-card-actions>
                </v-card>
                </v-col>
            </v-row>
        </v-dialog>

        <!-- /////////////////////////////////////////////////dialog for start date //////////////////////////////////////////// -->
        <v-dialog width="400" persistent v-model="dialogstartdate">
            <v-card
            class="py-8"
            >
                <v-card-title>
                    <v-row justify="center">
                    Start Date of Rental Activity
                    </v-row>
                    </v-card-title>
                <v-divider class="mt-1 mb-8"></v-divider>
                <v-card-text>
                    <template>
                    <v-row justify="center">
                        <v-date-picker 
                        v-model="startdate"
                        elevation="12"
                        locale="en-US"
                        ></v-date-picker>
                    </v-row>
                    </template>
                </v-card-text>
                <v-divider class="my-4"></v-divider>
                 <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn
            color="blue darken-1"
            text
            @click="formatdate"
          >
            Okay
          </v-btn>
        </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- ////////////////////////////////////////////////end dialog /////////////////////////////////////////////////////// -->
        <div class="pb-2 pr-1" style="background-color:black;color:white">
            <v-row class="mr-0 mt-0" justify="end">
                Landlord License Application
            </v-row>
        </div>
        <v-row>
            <v-col>
                <v-row justify="center">
<!-- /////////////////////////////////////////////////Notice//////////////////////////////////////////////////////// -->
                    
                        <v-card
                        outlined
                        elevation="12"
                        color="teal lighten-4"
                        class="ma-6"
                        v-if="start"
                        max-width="600"
                        >
                            <v-card-title>Instructions for completing the Landlord License Application</v-card-title>
                            <v-divider class="mb-4"></v-divider>
                            <v-card-text>
                                <v-row justify="center">
                                    <v-col>
                                    Any person renting or leasing real property for gain, either commercial or residential, is required to obtain a general business license
under <a target="_blank" href="https://www.codepublishing.com/WA/Bremerton/html/Bremerton05/Bremerton0502.html">BMC 5.02</a>. Additionally, residential landlords are required to sign a declaration that their properties comply with the standards set
forth in the Washington State Landlord Tenant Act <a target="_blank" href="https://apps.leg.wa.gov/rcw/default.aspx?cite=59.18.060">(RCW 59.18.060)</a> under <a target="_blank" href="https://www.codepublishing.com/WA/Bremerton/html/Bremerton05/Bremerton0506.html">BMC 5.06</a>.

                                </v-col>
                                </v-row>
                                <v-divider class="my-4"></v-divider>
                                <v-row justify="center">
                                    <v-col>
<h3>Fee Due:</h3> The license fee is currently $75.00 per year, but is prorated for new applicants to $37.50 for landlords that begin renting
after July 1st. License fees are non-refundable. Licenses are renewed annually.
                                </v-col>
                                </v-row>
                                 <v-row justify="center">
                                    <v-col>
                                        <h3>Mailing Address For License and Renewals:</h3> Our office will default the mailing address for licenses and renewals to that of the
Property Owner.
                                    </v-col>
                                 </v-row>
                                 <v-row justify="center">
                                    <v-col>
                                        <h3>Property Owner: (Required for Commercial and/or Residential landlords)</h3> For the purpose of this license, "property owner" means
the person(s) in whom is vested all or any part of the legal title to the rental property, of all or part of the beneficial ownership and right to
present use and enjoyment of the property. Provide the property owner's name, phone number, mailing address, and email address in the
space provided. Email is the preferred method of contact used by BPD for the Landlord Notification Program.
                                    </v-col>
                                 </v-row>
                                 <v-row justify="center">
                                    <v-col>
                                        <h3>Secondary Point of Contact: (Optional)</h3> In the space provided, fill in the name and contact information of a secondary point of contact.
                                    </v-col>
                                 </v-row>
                                 <v-row justify="center">
                                    <v-col>
<h3>Rental Properties: (Required for Commercial and/or Residential landlords)</h3> In the space provided, list the address and number
of units per address for all of your rental properties within the City limits of Bremerton. For each address check the appropriate box
for property type, residential or commercial.
                                    </v-col>
                                 </v-row>
                                 <v-divider class="ma-8"></v-divider>
                                 <v-row>
                                     <v-col>
                                         <h3>Apply:</h3>When you click begin, there will be three simple steps to fill out
                                         <br/> <v-icon>mdi-numeric-1</v-icon> Property Owner information 
                                         <br/> <v-icon>mdi-numeric-2</v-icon> Secondary Contact (optional)
                                         <br/> <v-icon>mdi-numeric-3</v-icon> List of rental properties
                                         
                                     </v-col>
                                 </v-row>
                                    <v-row justify="center">
                                         <v-btn elevation="12" class="mb-4" color="success" @click="begin">Begin</v-btn>
                                         </v-row>
                            </v-card-text>
                        </v-card>
                    
<!-- /////////////////////////////////////////////////////// property owner information //////////////////////////// -->
                    <transition
                        :name="tran"
                        mode="out-in"
                        
                    >
                    <v-card
                    outlined
                    elevation="12"
                    color="teal lighten-4"
                    class="ma-6"
                    max-width="800"
                    v-if="step1"
                    >
                        <v-card-title>Property Owner Information</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                    outlined
                                    background-color="teal lighten-5"
                                    dense
                                    label="First Name"
                                    v-model="pofname"
                                    ></v-text-field>
                                </v-col> 
                                <v-col>
                                    <v-text-field
                                    outlined
                                    background-color="teal lighten-5"
                                    dense
                                    label="Last Name"
                                    v-model="polname"
                                    ></v-text-field>
                                </v-col>    
                                <v-col>
                                    <v-text-field
                                    outlined
                                    background-color="teal lighten-5"
                                    dense
                                    label="Business Name"
                                    v-model="bname"
                                    ></v-text-field>
                                </v-col>    
                            </v-row> 
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field
                                    outlined
                                    background-color="teal lighten-5"
                                    dense
                                    label="Phone"
                                    v-model="pophone"
                                    ></v-text-field>
                                </v-col><v-col>
                                    <v-text-field
                                    outlined
                                    background-color="teal lighten-5"
                                    dense
                                    label="Email"
                                    v-model="poemail"
                                    @blur="checkemail"
                                    ></v-text-field>
                                </v-col>
                                <v-col >
                                    <v-text-field
                                    outlined
                                    dense
                                    background-color="teal lighten-5"
                                    persistent-placeholder=""
                                    label="Start Date of Rental Activity"
                                    v-model="startdateshow"
                                    @click="startdatepopup"
                                    ></v-text-field>
                                </v-col> 
                            </v-row>
                                <v-row>
                               
                                <!-- ///////////////////////////////////////////////////physical address -->
                                <v-col >
                                <v-sheet
                                rounded
                                color="teal lighten-2"
                                outlined
                                min-width="300"
                                >
                                    <v-row class="mt-4" justify="center"><h3>Property Owner's Physical Address</h3></v-row>
                                    
                                    <v-text-field
                                    v-model="pal1"
                                    class="mx-2 mt-16"
                                    @input="poupdate"
                                    dense
                                    outlined
                                    color="teal darken-4"
                                    background-color="teal lighten-4"
                                    label="Address Line 1"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                    v-model="pal2"
                                    class="mx-2 mt-0 mb-0 pa-0"
                                    @input="poupdate"
                                    dense
                                    outlined
                                    color="teal darken-4"
                                    background-color="teal lighten-4"
                                    label="Address Line 2"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                    v-model="pal3"
                                    class="mx-2 mt-0 mb-0 pa-0"
                                    @input="poupdate"
                                    dense
                                    outlined
                                    color="teal darken-4"
                                    background-color="teal lighten-4"
                                    label="Address Line 3"
                                    >
                                    </v-text-field>
                                    <v-row>
                                        <v-col class="my-0 ml-2 mr-0 py-0">
                                            <v-text-field
                                            v-model="pacity"
                                            @input="poupdate"
                                            outlined
                                            background-color="teal lighten-4"
                                            dense
                                            label="City"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="2" class="ma-0 pa-0">
                                            <v-text-field
                                            v-model="pastate"
                                            @input="poupdate"
                                            outlined
                                            background-color="teal lighten-4"
                                            dense
                                            label="State"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="my-0 py-0 mr-2">
                                            <v-text-field
                                            v-model="pazip"
                                            @input="poupdate"
                                            outlined
                                            background-color="teal lighten-4"
                                            dense
                                            label="Zip"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-sheet> 
                                
                                </v-col>
                                    <!--  ///////////////////////////////////////////////////mailing address///////////////// --> 
                                <v-col >
                                    
                                    <v-sheet
                                    
                                    rounded
                                    color="teal lighten-2"
                                    outlined
                                    class="ma-0 pa-0"
                                    min-width="300"
                                    >
                                    <v-row class="mt-4 mb-2" justify="center"><h3>Property Owner's Mailing Address</h3></v-row>
                                    
                                    <v-row class="mt-0 mb-0 ml-4 pa-0"> <v-checkbox @change="checkbox" class="ma-0 pa-0" v-model="sapa"></v-checkbox> same as physical address</v-row>

                                    <v-text-field
                                    v-model="mal1"
                                    class="mx-2 mt-0"
                                    dense
                                    outlined
                                    color="teal darken-4"
                                    background-color="teal lighten-4"
                                    label="Address Line 1"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                    v-model="mal2"
                                    class="mx-2 mt-0 mb-0 pa-0"
                                    dense
                                    outlined
                                    color="teal darken-4"
                                    background-color="teal lighten-4"
                                    label="Address Line 2"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                    v-model="mal3"
                                    class="mx-2 mt-0 mb-0 pa-0"
                                    dense
                                   outlined
                                    color="teal darken-4"
                                    background-color="teal lighten-4"
                                    label="Address Line 3"
                                    >
                                    </v-text-field>
                                    <v-row>
                                        <v-col class="my-0 ml-2 mr-0 py-0">
                                            <v-text-field
                                            v-model="macity"
                                            outlined
                                            background-color="teal lighten-4"
                                            dense
                                            label="City"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="2" class="ma-0 pa-0">
                                            <v-text-field
                                            v-model="mastate"
                                            outlined
                                            background-color="teal lighten-4"
                                            dense
                                            label="State"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="my-0 py-0 mr-2">
                                            <v-text-field
                                            v-model="mazip"
                                            outlined
                                            background-color="teal lighten-4"
                                            dense
                                            label="Zip"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-sheet> 
                                </v-col>
                                </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row justify="center">
                                <v-btn
                                    class="ma-8"
                                    elevation="12"
                                    color="success"
                                    @click="next(2)"
                                >Next</v-btn>
                            </v-row>
                            

                        </v-card-actions>
                    </v-card>
                    </transition>   
<!-- ///////////////////////////////////////////end property owner information ///////////////////////////////// -->
<!-- //////////////////////////////////////// secondary contact optional /////////////////////////////////////// -->
                    <transition
                        :name="tran"
                        mode="out-in"
                    >
                    <v-card
                    outlined
                    elevation="12"
                    color="teal lighten-4"
                    class="ma-6"
                    width="400"
                    v-if="step2"
                    >
                        <v-card-title>Secondary Contact (Optional)</v-card-title>
                        
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-text-field
                            v-model="scname"
                            outlined
                            dense
                            label="Name"
                            background-color="teal lighten-5"
                            ></v-text-field>

                             <v-text-field
                             v-model="scphone"
                            outlined
                            dense
                            label="Phone"
                            background-color="teal lighten-5"
                            ></v-text-field>

                            <v-text-field
                            v-model="scemail"
                            outlined
                            dense
                            label="Email"
                            background-color="teal lighten-5"
                            ></v-text-field>
                            <v-divider class="mb-4"></v-divider>
                            <v-text-field
                            v-model="scaddress"
                            outlined
                            dense
                            label="Address"
                            background-color="teal lighten-5"
                            ></v-text-field>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                    v-model="sccity"
                                    outlined
                                    dense
                                    label="City"
                                    background-color="teal lighten-5"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                    v-model="scstate"
                                    outlined
                                    dense
                                    label="State"
                                    background-color="teal lighten-5"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                    v-model="sczip"
                                    outlined
                                    dense
                                    label="Zip"
                                    background-color="teal lighten-5"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row justify="center">
                                <v-btn
                                    class="ma-8"
                                    elevation="12"
                                    color="success"
                                    @click="next(3)"
                                >Next</v-btn>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                    </transition>
<!-- ////////////////////////////////////////////////////////////////end secondary contact  ////////////////////////////////////// -->

<!-- ////////////////////////////////////////////////////////  start rental properties   //////////////////////// -->
                    <transition
                        :name="tran"
                        mode="out-in"
                     >
                        <v-card
                            outlined
                            elevation="12"
                            color="teal lighten-5"
                            class="ma-6"
                            max-width="800"
                            v-if="step3"
                            min-width="600"
                        >
                            
                            <v-card-title>Rental Properties</v-card-title>
                            <v-divider class="ma-0"></v-divider>
                            <v-card-text>
                               <v-row> 
                                   <v-col>
                                <v-row justify="center">
                                    List Addresses of all Rentals within the City of Bremerton
                                </v-row>
                                <v-row justify="center">   
                                    Click the button below to add an address.
                                </v-row>
                                <v-row justify="center">
                                    Add as many addresses as needed
                                </v-row>
                                
                                <v-row>
                                    <v-divider class="ma-4"></v-divider>
                                </v-row>
                                    <v-row v-for="x in addresses" :key="x.prikey">
                                        <v-col cols="12">
                                            <v-expand-transition>
                                            <v-sheet v-if="dialogsa && addrprikey == x.prikey" elevation="24">
                                                <v-row justify="center" class="mb-4"><b>Please Click on the rental Address to select it</b></v-row>
                                                <v-row justify="center">
                                                    <v-progress-circular indeterminate v-if="startcircle" color="primary"></v-progress-circular>
                                                </v-row>
                                                 
                                                <v-expand-transition>
                                                <v-sheet width="100%" v-if="addguesses.length>0">
                                                   <table  rules="all" width="100%">
                                                        <tr ><td><b><center>Address</center></b></td><td><b><center>City</center></b></td><td><b><center>Jurisdiction</center></b></td></tr>
                                                        <tr v-for="x in addguesses" :key="x.attributes.SITUS_ID" :class="x.attributes.rowcolor" @click="useaddress(x)" >
                                                            <td class="ma-2">{{x.attributes.FULL_ADDR}}</td>
                                                            <td class="ma-2">{{x.attributes.CITY}}</td>
                                                            <td class="ml-3">
                                                                <v-spacer></v-spacer>    
                                                                {{x.attributes.JURISDICT}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-sheet>
                                                </v-expand-transition>
                                                <v-row v-if="addguesses.length==0" justify="center" class="mb-4"><h3>No Addresses found</h3></v-row>
                                            </v-sheet>
                                      </v-expand-transition>

                                            <v-sheet class="pa-0 ma-0" elevation="12" outlined>
                                                <v-row>
                                                    <v-text-field @input="precheckaddress(x)" class="mt-6 mx-6" v-model="x.ral1" filled dense outlined persistent-placeholder="" label="Address line1"></v-text-field>
                                                    <button justify="right" type = "button" class="close me-9" @click="removeaddress(x.prikey)" v-if="x.prikey>=1"> X </button>
                                                    
                                                    
                                                </v-row>
                                                <v-expand-transition>
                                                <v-sheet height="300" v-if="restofaddress && addrprikey == x.prikey">
                                                    <v-row>
                                                        
                                                            <v-text-field class="mt-0 mx-6" v-model="x.ral2" dense outlined persistent-placeholder="" label="Address line2"></v-text-field>
                                                        
                                                    </v-row>
                                                    <v-row class="ma-0 pa-0">
                                                        <v-col>
                                                            <v-text-field v-model="x.racity" readonly dense outlined  label="City" value=""></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field v-model="x.rastate" readonly dense outlined  label="State" value=""></v-text-field>
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field v-model="x.razip" readonly dense outlined  label="Zip" ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="ma-0 pa-0">
                                                        <v-col class="ma-0 pa-0">
                                                            
                                                       
                                                            <v-row justify="center" >
                                                                <v-sheet class="pa-0 ma-0" elevation="0">
                                                                <v-text-field class="mt-2 mx-0 mb-0" 
                                                                    :background-color="x.ranou.length<1?'red lighten-4':'green lighten-4'" 
                                                                    v-model="x.ranou" 
                                                                    dense 
                                                                    @input="turnonbuttons(x.prikey)"
                                                                    outlined 
                                                                    persistent-placeholder="" 
                                                                    label="Number of Units"></v-text-field>
                                                                <v-sheet class="pa-0 mb-0" outlined rounded :color="x.ratype.length<1?'red lighten-4':'green lighten-4'" elevation="0">
                                                                    <small>Type of Property</small>
                                                                <v-radio-group :color="x.ratype.length<1?'red lighten-4':'green lighten-4'" row v-model="x.ratype" >
                                                                    <v-radio @click="turnonbuttons(x.prikey)" value="residential" label="Residential"></v-radio>
                                                                    <v-radio @click="turnonbuttons(x.prikey)" value="commercial" label="Commercial"></v-radio>
                                                                </v-radio-group>
                                                                </v-sheet>
                                                                </v-sheet>
                                                            </v-row>
                                                        </v-col>   
                                                        <v-col class="ma-0 pa-0">
                                                            <v-row justify="center">
                                                                <v-btn @click="addaddress" width="220" :disabled="!tob" class="ma-2" height="70" color="teal lighten-3">Add another Address</v-btn>
                                                            </v-row>
                                                            <v-row justify="center">
                                                                <v-btn @click="submit" width="220" :disabled="!tob" class="ma-2" height="70" color="teal lighten-3">continue to Next step</v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                    
                                                </v-sheet>
                                                </v-expand-transition>

                                            </v-sheet>

                                        </v-col>
                                    </v-row>
                                   
                                      
                                   </v-col>
                                <!-- <v-col class="ma-0 pa-0 me-15 mt-15">
                                            <v-row class="d-flex justify-end align-self-center">
                                                <v-btn @click="addaddress" width="220" :disabled="!tob" class="ma-2" height="70" color="teal lighten-3">Add another Address</v-btn>
                                            </v-row>
                                            <v-row class="d-flex justify-end align-self-center">
                                                    <v-btn @click="submit" width="220" :disabled="!tob" class="ma-2" height="70" color="teal lighten-3">continue to Next step</v-btn>
                                            </v-row>
                                        </v-col> -->

                                </v-row>

                            </v-card-text>
                            
                        </v-card>
                    </transition>
            <!-- //////////////////////////////////// end renatl properties ////////////////////////// --> 
                        </v-row>
                    </v-col>
                </v-row>
        </v-app>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            restofaddress:false,
            startcircle:false,
            prikey:'',
            tob:false,
            addrprikey:'',
            dialogsa:false,
            dialogbadaddress:false,
            sapa:false,
            applemail:'',
            emaillist:[],
            AcctNo:'12345',  //required for paymentus
            bill:'',    //75 or prorated for 35
            ifs:'',
            bname:'',
            gohome:false,
            start:true,
            step1:false,
            step2:false,
            step3:false,
            step4:false,
            llta:false, //landlord tenant act
            error:false,
            signature:false,
            dialog:false,
            dialogtitle:'',
            dialogtext:'',
            dialogcolor:'',
            dialogemaillist:false,
            dialogdone:false,
            pay:'',
            addresses:[],
            addguesses:[],
            pofname:'',  //Property Owner Name
            polname:'',
            pophone:'',
            poemail:'',
            poemailtested:false,
            mal1:'',    //Mailing Address line 1
            mal2:'',
            mal3:'',
            macity:'',
            mastate:'',
            mazip:'',
            pal1:'',    //Pysical Address line 1
            pal2:'',
            pal3:'',
            pacity:'',
            pastate:'',
            pazip:'',
            scname:'',  //secondary contact name
            scphone:'',
            scemail:'',
            scaddress:'',
            sccity:'',
            scstate:'',
            sczip:'',
            startdate:'',
            startdateshow:'',
            dialogstartdate:false,
            tran:"fade",
            //tran:"fab-transition",
        }
    },
    mounted() {
     window.scrollTo(0,0);
    },
    
    methods:{
        turnonbuttons(x){
            if(this.addresses[x].ranou && this.addresses[x].ratype){
                this.tob=true;
            }else{
                this.tob=false;
            }
        },
        //this function removes addresses in the apply vue. user can click the x button to remove address text field
        removeaddress(ind) {
            this.addresses = this.addresses.filter(x => x.prikey !== ind);  
        },
        //this function finds the prikeys for text fields that are left null. these prikeys are used to remove addresses
        findprikey(address) {
            const foundPrikey = address
            .filter(address => address.ral1 == "" || address.ranou == "" || address.ratype == "" || address.razip == "")
            .map(address => address.prikey);

            return foundPrikey
        },
        validateemail(email) { 
            //reg expression pattern for email validation
            let emailPattern = /^\S+@\S+\.\S+$/;
            
            //remove whitespace
            email = email.trim();

            //check if email is empty or null
            if(email.length === 0 || email.length === null) {
                this.dialog=true;
                this.dialogtitle="No Email";
                this.dialogtext="Please enter an email address. If you renew your landlord license in the next calander year, your email address will be used as your username";
                this.dialogcolor="amber lighten-4";
                return;
                
            }
            //test email against pattern
            return emailPattern.test(email);
        },
        validatephonenumber(phoneNumber) {
            //reg expression pattern for phone number validation
            let phonePattern = /^(\(\d{3}\)-\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{10})$/; // Matches phone numbers in the formats (123)-456-7890, 123-456-7890, or 1234567890
        
            //remove any non-digit characters from the phone number
            let cleanedPhoneNumber = phoneNumber.replace(/[^\d()-]/g, "");
        
            //check if the phone number is empty or null
            if (cleanedPhoneNumber.length === 0 || cleanedPhoneNumber === null) {
                this.dialog=true;
                this.dialogtitle="No Phone Number";
                this.dialogtext="Please enter a valid phone number. We may need your phone number if we need to contact you";
                this.dialogcolor="amber lighten-4";
                return;
            }
        
            //test the phone number against the pattern
            return phonePattern.test(cleanedPhoneNumber);
        },
        validatezipcode(zipcode) {
            //reg expression pattern for zip code validation
            let zipPattern = /^\d{5}$/;

            //remove characters from zip code
            let cleanedZipCode = zipcode.replace(/\D/g, "");

            //check if zip code is empty or null
            if(cleanedZipCode.length === 0 || cleanedZipCode === null) {
                this.dialog=true;
                this.dialogtitle="No Zip Code";
                this.dialogtext="Please enter a valid zip code.";
                this.dialogcolor="amber lighten-4";
                return;
            }

            return zipPattern.test(cleanedZipCode);


        },
        useaddress(x){
            if(x.attributes.rowcolor=='rowbad'){
                this.dialogbadaddress=true;
                this.restofaddress=false;
            }else{
                let fa=x.attributes.FULL_ADDR;
                let city=x.attributes.CITY;
                let state=x.attributes.STATE;
                let zip=x.attributes.ZIP_CODE;
                window.console.log(fa + city + state + zip);
                this.addresses[this.addrprikey].ral1=fa;
                this.addresses[this.addrprikey].racity=city;
                this.addresses[this.addrprikey].rastate=state;
                this.addresses[this.addrprikey].razip=zip;
                this.dialogsa=false;
                this.restofaddress=true;
            }
        },
        precheckaddress(x){
            this.startcircle=true;
            this.checkaddress(x);
        },
        checkaddress(x){
            
            this.addrprikey=x.prikey;
            this.restofaddress=false;
            let y=x.ral1;
            if(y.length<4){
                this.dialogsa=false;
                this.startcircle=false;
                return;
            }
            let yA=y.split(" ");
            let w='1=1 ';
            for(let z=0;z<yA.length;z++){
                w=w+" and FULL_ADDR like '%"+yA[z]+"%'";
            }
            
            let thisvue = this;
            let url = this.$store.state.url3;
            const params = new URLSearchParams();

            params.append('where',w);
            params.append('timeRelation', 'esriTimeRelationOverlaps');
            params.append('geometryType','esriGeometryEnvelope');
            params.append('spatialRel','esriSpatialRelIntersects');
            params.append('units','esriSRUnit_Foot');
            params.append('outFields','*');
            params.append('returnGeometry','false');
            params.append('returnTrueCurves','false');
            params.append('returnIdsOnly','false');
            params.append('returnCountOnly','false');
            params.append('returnZ','false');
            params.append('returnM','false');
            params.append('returnDistinctValues','false');
            params.append('returnExtentOnly','false');
            params.append('sqlFormat','none');
            params.append('featureEncoding','esriDefault');
            params.append('resultRecordCount','20');
            params.append('f','pjson');
              
                        
            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
                if(response.data.exceededTransferLimit){
                    window.console.log("exceeded");
                }else{
                    for(let i=0;i<response.data.features.length;i++){
                        if(response.data.features[i].attributes.JURISDICT=="BR"){
                        response.data.features[i].attributes.JURISDICT="Bremerton";
                        response.data.features[i].attributes.rowcolor="rowgood";
                        }else{
                            response.data.features[i].attributes.rowcolor="rowbad";
                        }

                        if(response.data.features[i].attributes.JURISDICT=="BI"){
                        response.data.features[i].attributes.JURISDICT="Bainbridge";
                        }

                        if(response.data.features[i].attributes.JURISDICT=="CO"){
                        response.data.features[i].attributes.JURISDICT="County";
                        }
                        if(response.data.features[i].attributes.JURISDICT=="PO"){
                        response.data.features[i].attributes.JURISDICT="Port Orchard";
                        }
                        if(response.data.features[i].attributes.JURISDICT=="PB"){
                        response.data.features[i].attributes.JURISDICT="Poulsbo";
                        }
                    }

                   window.console.log(response.data); 
                thisvue.addguesses=response.data.features;
                thisvue.dialogsa=true;
                thisvue.startcircle=false;
                }
                
            });
        },
        poupdate(){
            if(this.sapa){
               this.mal1=this.pal1;
               this.mal2=this.pal2;
               this.mal3=this.pal3;
               this.macity=this.pacity;
               this.mastate=this.pastate;
               this.mazip=this.pazip;
            }
        },
        checkbox(){
            this.poupdate();
        },
        renew(x){
            window.console.log(x);
            let a=x.AcctNo;
            let e=this.poemail;
            this.$store.commit('setacem',{a,e});
            this.home();
        },
        checkemail(){
            if(this.poemailtested == true){
                return;
            }
            
            ////make sure this email has not been used already in the landlord database (it has a landlord account number), if so have them renew instead of apply
            ///if good return true to poemailtested so form can proceed to the next step
            let thisvue = this;
            let url = this.$store.state.url;
            let e=this.poemail;
            let data={email:e};
            data=JSON.stringify(data);

            const params = new URLSearchParams();
            params.append('ty', 'checkemail');
            params.append('data',data);
                        
            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
                let i;
                for(i in response.data){
                    if(response.data[i].Status == 'I'){
                        response.data[i].Status = 'Issued';
                    }
                    if(response.data[i].Status == 'C'){
                        response.data[i].Status = 'Closed';
                    }
                }

                thisvue.emaillist = response.data;
                if(thisvue.emaillist.length>0){
                    thisvue.dialogemaillist=true;
                    return;
                }
               /*
               if(response.data == "exists"){
                    thisvue.dialog=true;
                    thisvue.dialogtitle="Email Already Exists";
                    thisvue.dialogtext="This email is already associated with an account, please use the 'Renew Landlord License' option on the main page instead of applying for a new one.";
                    thisvue.dialogcolor="amber lighten-4";
                    thisvue.gohome=true;
                }
                if(response.data == "not approved"){
                    thisvue.dialog=true;
                    thisvue.dialogtitle="Email Already Used";
                    thisvue.dialogtext="This email has already been used to apply for a landlord license. The license has not been approved yet, when it is please use the 'Renew Landlord License' option on the main page instead of applying for a new one.";
                    thisvue.dialogcolor="amber lighten-4";
                }
                */
                if(response.data == "bad"){
                    thisvue.dialog=true;
                    thisvue.dialogtitle="Error";
                    thisvue.dialogtext="We are having trouble with our database, please try again later, thanx!";
                    thisvue.dialogcolor="amber lighten-4";
                }
            });
        },
        sendemail(){
            let thisvue = this;
            //this.bill=this.checkprorate();
            let phone = this.pophone.replace(/\D/g,'');
            let phone1=phone.substr(0,3);
            let phone2=phone.substr(3,3);
            let phone3=phone.substr(6,4);
            let email = this.poemail.trim();
            //let bill = this.amountpaid.substring(1);
            this.ifs=this.$store.state.url2+"?iframe=true&header.accountNumber="+
            this.AcctNo+"&header.paymentTypeCode=License&step=2&customer.email="+email+"&header.amount="+this.bill+
            "&customer.dayPhone.npa="+phone1+"&customer.dayPhone.nxx="+phone2+"&customer.dayPhone.did="+phone3+
            "&customer.firstName="+this.pofname+"&customer.lastName="+this.polname+"&customer.address.zipCode="+this.pazip;
            this.ifs=this.ifs.replace("iframe=true&","");
            
            
            
            let url = this.$store.state.url;
            let p=this.prikey;
            let i=this.ifs;
            let data={1:p,2:i};
             data=JSON.stringify(data);

            const params = new URLSearchParams();
            params.append('ty', 'sendemail');
            params.append('data',data);
            params.append('data2',this.bill);

            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
                let x=response.data;
                if(x!="bad"){
                thisvue.dialogdone=true;
                thisvue.paylicense();
                thisvue.applemail=x;
                }else{
                    window.console.log("bad");
                }
            });
        },
        paylicense(){
            /*
            this.bill=this.checkprorate();
            let phone = this.pophone.replace(/\D/g,'');
            let phone1=phone.substr(0,3);
            let phone2=phone.substr(3,3);
            let phone3=phone.substr(6,4);
            let email = this.poemail.trim();
            //let bill = this.amountpaid.substring(1);
            this.ifs=this.$store.state.url2+"?iframe=true&header.accountNumber="+
            this.AcctNo+"&header.paymentTypeCode=License&step=2&customer.email="+email+"&header.amount="+this.bill+
            "&customer.dayPhone.npa="+phone1+"&customer.dayPhone.nxx="+phone2+"&customer.dayPhone.did="+phone3+
            "&customer.firstName="+this.pofname+"&customer.lastName="+this.polname+"&customer.address.zipCode="+this.pazip;
            this.ifs=this.ifs.replace("iframe=true&","");
            */
            window.open(this.ifs, "_blank");
            //this.sendemail();
            //this.home(); popup that goes home but explains a account number will be emailed once the account is approved

        },
        home(){
            this.gohome=false;
            this.$router.replace({ name: "home" });
        },
        checkprorate(){
            // make prorate date
            //let d=new Date;
            //let y=d.getFullYear();
            //y=new Date(y, 6, 0);
            //  get start date
            var [year, month, day] = this.startdate.split('-'); //all that matters is that the month is less than 7
            console.log(year);
            console.log(day);
            let m=parseInt(month);
            console.log(m);
            //let z=new Date(year, month-1, day);
            // get differance in the dates
            return(m>6?37.5:75);
        },
        formatdate(){
            this.dialogstartdate=false;
            if(this.startdate != ""){
                const [year, month, day] = this.startdate.split('-');
                this.startdateshow=`${month}/${day}/${year}`;
            }
        },
        startdatepopup(){
            this.dialogstartdate=true;
        },
        submit(){
            //////////////////////////////////////////////////first make sure that there are some rental properties
            if(this.addresses.length<1){
                this.dialog=true;
                this.dialogtitle="No Rental Properties Listed";
                this.dialogtext="Please enter at least one rental property. ";
                this.dialogcolor="amber lighten-4";
                return;
            }
            /////////////////////////////////////////////////next make sure that the type of rental is selected
            let check1=0;
            let check2=0;
            let check3=0;
            
            //array to hold the addresses to be removed
            let pKey = this.findprikey(this.addresses);
            

            //loop through addresses to be removed and remove address using removeaddress ()
            pKey.forEach((prikey) => {    
                this.removeaddress(prikey);
            })

            
            for(let a in this.addresses){
                if(this.addresses[a].ratype == ""){check1++;}
                if(this.addresses[a].ral1 == ""){check2++;}
                if(this.addresses[a].ranou == ""){check3++;}
                if(this.addresses[a].ratype == "residential"){this.llta=true;}
            }
            if(check1 > 0){
                this.dialog=true;
                this.dialogtitle="Residential or Commercial not Selected";
                this.dialogtext="Please select either Residential or Commercial for each address. ";
                this.dialogcolor="amber lighten-4";
                return;
            }
            if(check2 > 0){
                this.dialog=true;
                this.dialogtitle="No Address";
                this.dialogtext="Please enter an address in the box labeled 'Address line 1' for each rental.";
                this.dialogcolor="amber lighten-4";
                return;
            }
            if(check3 > 0){
                this.dialog=true;
                this.dialogtitle="# of Units";
                this.dialogtext="Please enter the number of rental units at each address that you are listing.";
                this.dialogcolor="amber lighten-4";
                return;
            }
            this.step3 = false;
            let p=this.addresses.length;
            this.addresses.push({ral1:this.scaddress,ral2:'',racity:this.sccity,rastate:this.scstate,razip:this.sczip,ranou:'',ratype:'Secondary Contact',prikey:p,name:this.scname,phone:this.scphone,email:this.scemail});
            let thisvue = this;
            let url = this.$store.state.url;
            let data={"poname":this.pofname + " " + this.polname,"bname":this.bname,"pophone":this.pophone,"poemail":this.poemail,"mal1":this.mal1,"mal2":this.mal2,"mal3":this.mal3,"macity":this.macity,"dstarted":this.startdate,
            "mastate":this.mastate,"mazip":this.mazip,"pal1":this.pal1,"pal2":this.pal2,"pal3":this.pal3,"pacity":this.pacity,"pastate":this.pastate,"pazip":this.pazip,
            "scname":this.scname,"scphone":this.scphone,"scemail":this.scemail,"scaddress":this.scaddress,"sccity":this.sccity,"scstate":this.scstate,"sczip":this.sczip,"addresses":this.addresses};
            data=JSON.stringify(data);

            const params = new URLSearchParams();
            params.append('ty', 'apply');
            params.append('data',data);
            params.append('data2',this.bill);
                        
            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
                if(response.data != "bad"){
                    let x=response.data;
                    let xA=x.split("|");
                    thisvue.prikey=xA[1];
                    thisvue.AcctNo=xA[0];
                    thisvue.next(4);
                }else{
                    thisvue.step3=false;
                    thisvue.error=true;
                }
            });
            
        },
        addaddress(){
            let p=this.addresses.length;
            this.addresses.push({ral1:'',ral2:'',racity:'Bremerton',rastate:'Wa',razip:'',ranou:'',ratype:'',prikey:p,name:'',phone:'',email:''});
        },
        begin(){
            window.scrollTo(0,0);
            this.start=false;
            this.step1=true;
        },
        next(x){
            window.scrollTo(0,0);
            if(x==2){
               //check for start date
                if(this.startdate == ""){
                    this.dialog=true;
                    this.dialogtitle="No Start Date";
                    this.dialogtext="Please Enter A Start Date For This Year That The Unit Was Rented So That We Can Calculate The Prorated Annual License Amount";
                    this.dialogcolor="green lighten-4";
                    return;
                }
                // check property owners name
                if(this.pofname == "" || this.polname == ""){
                    this.dialog=true;
                    this.dialogtitle="No First and Last Name";
                    this.dialogtext="Please Enter A First And Last Name. We Need A Name In Case We Need To Contact You";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                // check property owners 
                // if(this.poemail == "" ){
                //     this.dialog=true;
                //     this.dialogtitle="No Email";
                //     this.dialogtext="Please enter an email address. If you renew your landlord license in the next calander year, your email address will be used as your username";
                //     this.dialogcolor="amber lighten-4";
                //     return;
                // }
                //email validation
                if(this.validateemail(this.poemail)) {
                    console.log("email ok", this.poemail);
                }
                else{
                    this.dialog=true;
                    this.dialogtitle="Invalid Email";
                    this.dialogtext="Please Enter A Valid Email Address. If You Renew Your Landlord License In The Next Calander Year, Your Email Address Will Be Used As Your Username";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                //phone number validation
                if(this.validatephonenumber(this.pophone)){
                    console.log("phone number ok", this.pophone);
                }
                else {
                    this.dialog=true;
                    this.dialogtitle="Invalid Phone Number";
                    this.dialogtext="Please Enter A Valid Phone Number. We May Need Your Phone Number If We Need To Contact You";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                // check phone number
                // if(this.pophone == "" ){
                //     this.dialog=true;
                //     this.dialogtitle="No Phone Number";
                //     this.dialogtext="Please enter a phone number. We may need your phone number if we need to contact you";
                //     this.dialogcolor="amber lighten-4";
                //     return;
                // }
                // check physical address
                if(this.pal1 == "" ){
                    this.dialog=true;
                    this.dialogtitle="No physical address";
                    this.dialogtext="Please Enter A Physical Address.";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                if(this.validatezipcode(this.pazip)) {
                    console.log("physical zip code ok", this.pazip);
                }
                else{
                    this.dialog=true;
                    this.dialogtitle="Invalid Physical Address Zip Code";
                    this.dialogtext="Please Enter A Valid Physical Address Zip Code.";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                // check mailing address
                if(this.mal1 == "" ){
                    this.dialog=true;
                    this.dialogtitle="No Mailing Address";
                    this.dialogtext="Please Enter A Mailing Address";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                if(this.validatezipcode(this.mazip)) {
                    console.log("mailing zip code ok", this.mazip);
                }
                else{
                    this.dialog=true;
                    this.dialogtitle="Invalid Mailing Address Zip Code";
                    this.dialogtext="Please Enter A Valid Mailing Address Zip Code.";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                if(this.emaillist.length>0 && this.poemailtested == false){
                    this.dialogemaillist=true;
                    return;
                }

                /*
                if(this.poemailtested == "exists"){
                    this.dialog=true;
                    this.dialogtitle="Email Already Exists";
                    this.dialogtext="This email is already associated with an account, please use the 'Renew Landlord License' option on the main page instead of applying for a new one.";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                if(this.poemailtested == "not approved"){
                    this.dialog=true;
                    this.dialogtitle="Email Already Used";
                    this.dialogtext="This email has already been used to apply for a landlord license. The license has not been approved yet, when it is please use the 'Renew Landlord License' option on the main page instead of applying for a new one.";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                */
                if(this.poemailtested == "bad"){
                    this.dialog=true;
                    this.dialogtitle="Error";
                    this.dialogtext="We are having trouble with our database, please try again later, thanx!";
                    this.dialogcolor="amber lighten-4";
                    return;
                }
                
                this.step1=false;
                this.bill=this.checkprorate().toFixed(2);
                 setTimeout(() => {
                    this.step2=true;
                }, 500); 
            }
            if(x==3){
                this.step2=false;
                this.addaddress();
                 setTimeout(() => {
                    this.step3=true;
                }, 500); 
            }
            if(x==4){
                this.step3=false;
                 setTimeout(() => {
                    this.step4=true;
                }, 500); 
            }
        },
    },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
.rowgood{
    border: 1px solid #bddff5;
    background-color: #d0f4fa;
    width:100%;
}
.rowbad{
    border: 1px solid #5a3c3c;
    background-color: #f8b7b7;
    width:100%;
}

</style>